import script from "./ReceiptPaymentLedger.vue?vue&type=script&setup=true&lang=js"
export * from "./ReceiptPaymentLedger.vue?vue&type=script&setup=true&lang=js"

import "./ReceiptPaymentLedger.vue?vue&type=style&index=0&id=1b35b9dc&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b35b9dc"]])

export default __exports__